<template>
  <v-container fluid class="align-start" style="margin-bottom: 56px">
    <v-card width="100%" class="mb-5">
      <v-container fluid class="pa-0">
        <v-layout>
          <v-row class="ma-0" style="max-width: 100%">
            <v-col class="pa-0">
              <v-row class="ma-0 px-4 pb-4 pt-1" align="center">
                <v-col class="px-0 pb-0 pt-3" cols="auto">
                  <v-toolbar-title style="min-width: 80px"> {{ $t('Navigation.MANAGER_WORK_SCHEDULES_TAB_TITLE') }}
                  </v-toolbar-title>
                </v-col>
                <v-divider class="mt-3 mx-3" vertical/>
                <v-spacer v-if="!isMdOrLargerViewport()"/>
                <v-col class="pa-0" cols="auto">
                  <v-row class="ma-0" align="center">
                    <div class="px-0 pb-0 pt-3">
                      <v-btn
                        @click="resetViewRangeDates"
                        outlined
                        small
                      >
                        {{ resetButtonText }}
                      </v-btn>
                    </div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div class="px-0 pb-0 pt-3">
                          <v-btn
                            @click="handleTimeRangePreviousPage()"
                            v-on="on"
                            text
                            icon
                          >
                            <v-icon class="pl-0">navigate_before</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span>{{ previousTimeRangeTooltip }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div class="px-0 pb-0 pt-3">
                          <v-btn
                            @click="handleTimeRangeNextPage()"
                            v-on="on"
                            text
                            icon
                          >
                            <v-icon class="pl-0">navigate_next</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span>{{ nextTimeRangeTooltip }}</span>
                    </v-tooltip>
                    <div class="text-h6 px-0 pb-0 pt-3">{{ currentTimeRange }}</div>
                  </v-row>
                </v-col>
                <v-spacer v-if="isMdOrLargerViewport()"/>
                <v-col class="pa-0" cols="auto" :style="{ width: isMdOrLargerViewport() ? '415px' : '100%' }">
                  <v-row class="ma-0">
                    <v-col class="pa-0" cols="auto" :style="{ width: isXsViewport() ? '100%' : '130px' }">
                      <v-select
                        @change="handleViewRangeChange"
                        v-model="viewRange.range"
                        :items="viewRanges"
                        class="pt-3"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                    <div class="px-3 pt-3" v-if="isMdOrLargerViewport()">
                      <v-divider vertical/>
                    </div>
                    <v-spacer v-if="!isMdOrLargerViewport()"/>
                    <v-col class="pa-0" cols="auto" :style="{ width: isXsViewport() ? '100%' : '260px' }">
                      <v-text-field
                        v-model="searchText"
                        class="pt-3"
                        append-icon="search"
                        :label="$t('filters.search')"
                        @click:clear="searchText = ''"
                        outlined
                        single-line
                        clearable
                        hide-details
                        dense
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider/>
              <v-row class="ma-0 pa-4" align="center">
                <v-col class="pa-0">
                  <v-row
                    :class="{ 'ma-0':  true, 'flex-nowrap': !isXsViewport() }"
                    style="border: 1px solid #E0E0E0; position: sticky; z-index: 4; top: 65px"
                  >
                    <v-col
                      :style="{ width: isXsViewport() ? '100%' : '240px !important' }"
                      cols="auto"
                      class="pa-0"
                    >
                      <v-card flat tile height="50px" class="ma-0" style="border-right: 1px solid #E0E0E0">
                        <v-row class="ma-0 pl-4 fill-height" align="center">
                          <v-checkbox
                            v-model="allAssignmentsSelected"
                            hide-details
                            class="pa-0 ma-0"
                            @change="selectAllAssignments"
                          />
                          <div class="pl-6 font-italic"> {{ $t('actions.selectAll') }}</div>
                        </v-row>
                      </v-card>
                    </v-col>
                    <v-col
                      class="pa-0"
                      :style="{ 'max-width': isXsViewport() ? '100%' : 'calc(100% - 240px)' }"
                    >
                      <v-row
                        v-on:scroll="scrollAllBars($event)"
                        ref="ws_bar_ticks"
                        style="overflow-x: auto"
                        class="ma-0"
                      >
                        <v-row
                          :style="{ 'min-width': getBarMinWidth() }"
                          class="ma-0 text-center"
                          justify="center"
                        >
                          <v-col
                            v-for="(tick, index) in viewRangeTicks"
                            v-bind:key="index"
                            :style="{
                                borderLeft: '1px solid var(--v-info-darken1)',
                                borderTop: '1px solid var(--v-info-darken1)'
                              }"
                            class="pa-0"
                          >
                            <v-row
                              :style="{
                              backgroundColor: index % 2 === 0 ? 'var(--v-info-base)' : 'white',
                              height: '25px'
                            }"
                              class="ma-0 text-overline"
                              align="end"
                              justify="center"
                            >
                              {{ tick.upperText }}
                            </v-row>
                            <v-row
                              :style="{
                              backgroundColor: index % 2 === 0 ? 'var(--v-info-base)' : 'white',
                              height: '25px'
                            }"
                              class="ma-0 text-caption"
                              align="start"
                              justify="center"
                            >
                              {{ tick.lowerText }}
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0 flex-nowrap" style="border: 1px solid #E0E0E0;">
                    <v-card :loading="!subordinatesLoaded || !schedulesLoaded
                    || tempWorkScheduleAssignmentStatusPolling" flat tile width="100%">
                      <v-row
                        v-for="(assignment, index) in filteredSubordinateAssignments"
                        :class="{ 'ma-0': true, 'flex-nowrap': !isXsViewport() }"
                        :style="{
                          'height': getBarHeight(),
                          'overflow': 'hidden',
                        }"
                        :ref="getBarRef(assignment.id)"
                        :key="index"
                      >
                        <v-col
                          :style="{
                            width: isXsViewport() ? '100%' : '240px !important',
                            height: isXsViewport() ? '60px' : getBarHeight(),
                            position: isXsViewport() ? 'sticky' : 'static',
                            left: '0'
                          }"
                          cols="auto"
                          class="pa-0"
                        >
                          <v-list-item
                            :value="assignment.id"
                            :style="{
                              height: isXsViewport() ? '60px' : getBarHeight(),
                              position: 'sticky',left:'30px'
                            }"
                            v-ripple="false"
                            dense
                          >
                            <template v-slot:default="">
                              <v-list-item-action>
                                <v-checkbox multiple v-model="selectedAssignmentIds" :value="assignment.id"/>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-row class="ma-0" align="center">
                                  <div
                                    class="hover-pointer"
                                    :style="{width: isXsViewport() ? '80%' : '120px',  wordWrap: 'break-word'}"
                                    @click="viewAssignmentInfo(assignment)"
                                  >
                                    <div v-if="assignment.employeeName.length < 17 || isMobile()">
                                      {{ `${assignment.employeeName}` }}
                                    </div>
                                    <div v-else>
                                      {{ `${assignment.employeeName.split(",")[0]},` }}
                                      <br/>
                                      {{ assignment.employeeName.split(",")[1] }}
                                    </div>
                                    <div style="font-size: 12px; padding-top: 5px">
                                        {{ `${assignment.id}` }}
                                    </div>
                                  </div>
                                  <v-speed-dial
                                    v-model="speedDials[index]"
                                    direction="left"
                                    transition="slide-x-transition"
                                    style="z-index: 3"
                                    right
                                    absolute
                                  >
                                    <template v-slot:activator>
                                      <v-badge
                                        :value="isTempWorkScheduleUpsertFailureHidden(assignment)"
                                        color="warning"
                                        bordered
                                        dot
                                        overlap
                                      >
                                        <v-btn
                                          elevation="0"
                                          small
                                          icon
                                        >
                                          <v-icon>
                                            {{ speedDials[index] ? 'close' : 'menu_open' }}
                                          </v-icon>
                                        </v-btn>
                                      </v-badge>
                                    </template>
                                    <v-chip
                                      style="height:40px; border-radius: 50px;"
                                      class="px-0 elevation-3"
                                      color="primary lighten-1"
                                    >
                                      <v-btn
                                        @click="viewAssignmentInfo(assignment)"
                                        fab
                                        icon
                                        dark
                                        x-small
                                      >
                                        <v-icon>info</v-icon>
                                      </v-btn>
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                            @click="handleIndividualTempScheduleAssignment(assignment)"
                                            v-on="on"
                                            fab
                                            icon
                                            dark
                                            x-small
                                          >
                                            <v-icon>event</v-icon>
                                          </v-btn>
                                        </template>
                                        <span> {{ $t('workSchedules.assignTemp') }}</span>
                                      </v-tooltip>
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                            @click="viewWorkScheduleAssignmentHistory(assignment)"
                                            v-on="on"
                                            fab
                                            icon
                                            dark
                                            x-small
                                          >
                                            <v-badge
                                              :value="isTempWorkScheduleUpsertFailureHidden(assignment)"
                                              color="warning"
                                              dot
                                              overlap
                                            >
                                              <v-icon>history</v-icon>
                                            </v-badge>
                                          </v-btn>
                                        </template>
                                        <span> {{ $t('workSchedules.viewHistory') }}</span>
                                      </v-tooltip>
                                    </v-chip>
                                  </v-speed-dial>
                                </v-row>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                          <v-divider :key="`divider-${index}`"/>
                        </v-col>
                        <v-col
                          class="pa-0"
                          :style="{
                            'max-width': isXsViewport() ? '100%' : 'calc(100% - 240px)',
                             overflowX: 'visible',
                             height: getBarHeight()
                          }"
                        >
                          <v-row
                            v-on:scroll="scrollAllBars($event, assignment.id)"
                            v-if="schedulesLoaded"
                            style="overflow-x: visible"
                            class="ma-0"
                          >
                            <v-fade-transition hide-on-leave>
                              <v-card
                                v-show="schedulesLoaded"
                                :style="{
                                  'min-width': getBarMinWidth(),
                                  'overflow-x': 'visible'
                                }"
                                width="100%"
                                flat
                                tile
                              >
                                <v-row
                                  v-if="schedulesLoaded"
                                  class="ma-0"
                                  style="overflow-x: visible"
                                >
                                  <v-col class="pa-0">
                                    <v-card
                                      flat
                                      class="employeeRowCard"
                                      style="background-color: #f5f5f5;"
                                    >
                                      <v-row
                                        class="ma-0 employeeRow"
                                        :style="{ height: getBarHeight() }"
                                      >
                                        <work-schedule-block
                                          :key="index"
                                          :is-week-view="isWeekView"
                                          :view-range="viewRange"
                                          :schedule="getDailyWorkScheduleByEmployee(assignment.id)"
                                          @viewMoreInfo="viewScheduleDetails"
                                        />
                                      </v-row>
                                     <v-divider/>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-fade-transition>
                          </v-row>
                          <v-row
                            v-else
                            class="ma-0"
                            style="border-bottom: 1px solid #E0E0E0; border-left: 1px solid #E0E0E0; height:100%"
                            justify="center"
                            align="center"
                          >
                            <span class="text-overline">
                              Loading Schedules
                            </span>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-layout>
      </v-container>
    </v-card>
    <v-bottom-navigation grow fixed dark background-color="primary">
      <v-spacer/>
      <v-btn
        text
        :disabled="!assignmentSelectionValid"
        @click="assignSchedule"
      >
        {{ $t('workSchedules.assign') }}
        <v-icon>event</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <ApprovalsWorkScheduleAssignmentDialog
      :value="assignWorkSchedulesDialog"
      :assignments="getSelectedSubordinateAssignments()"
      @close="handleWorkScheduleAssignmentDialogClose"
    />
    <ApprovalsWorkScheduleAssignmentHistoryDialog
      :value="workSchedulesAssignmentHistoryDialog"
      :assignment="assignmentHistorySelection"
      @close="workSchedulesAssignmentHistoryDialog = false"
    />
    <ApprovalsWorkScheduleEmployeeInfoDialog
      :value="workSchedulesEmployeeInfoDialog"
      :assignment-info="assignmentInfoSelection"
      @close="workSchedulesEmployeeInfoDialog = false"
    />
    <WorkScheduleDetailsDialog
      :value="workScheduleDetailsDialog"
      :work-schedule-external-code="selectedExternalCode"
      @close="handleWorkScheduleDetailsDialogClose"
    />
  </v-container>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import constants from '@/constants';

import displayAdaptable from '@/mixins/displayAdaptable';
import hasSnackbar from '@/mixins/hasAppSnackbar';
import getWorkScheduleExternalNameBySchedule from '@/mixins/getWorkScheduleExternalName';

import DateTimeUtil from '@/util/date-time-util';

import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import last from 'lodash/last';
import includes from 'lodash/includes';
import first from 'lodash/first';
import map from 'lodash/map';
import flatMap from 'lodash/flatMap';
import extend from 'lodash/extend';
import reduce from 'lodash/reduce';
import filter from 'lodash/filter';
import every from 'lodash/every';
import some from 'lodash/some';

import format from 'date-fns/format';

import ApprovalsWorkScheduleAssignmentDialog from '@/components/approvals/ApprovalsWorkScheduleAssignmentDialog.vue';
import ApprovalsWorkScheduleAssignmentHistoryDialog
  from '@/components/approvals/ApprovalsWorkScheduleAssignmentHistoryDialog.vue';
import ApprovalsWorkScheduleEmployeeInfoDialog
  from '@/components/approvals/ApprovalsWorkScheduleEmployeeInfoDialog.vue';
import WorkScheduleDetailsDialog from '@/components/dialogs/WorkScheduleDetailsDialog.vue';
import WorkScheduleBlock from '@/components/WorkScheduleRow.vue';
import workSchedule from '../../workSchedule';

export default {
  name: 'ApproverWorkSchedules',

  components: {
    WorkScheduleDetailsDialog,
    WorkScheduleBlock,
    ApprovalsWorkScheduleEmployeeInfoDialog,
    ApprovalsWorkScheduleAssignmentHistoryDialog,
    ApprovalsWorkScheduleAssignmentDialog,
  },

  mixins: [
    displayAdaptable,
    hasSnackbar,
    getWorkScheduleExternalNameBySchedule,
    workSchedule,
  ],

  data() {
    return {
      subordinatesLoaded: false,
      allAssignmentsSelected: false,
      shouldDisplayExtraInfo: false,
      assignmentSelectionValid: false,
      selectedAssignmentIds: [],
      selectedExternalCode: '',
      assignmentHistorySelection: {},
      assignmentInfoSelection: {},
      searchText: '',
      assignWorkSchedulesDialog: false,
      workScheduleDetailsDialog: false,
      workSchedulesAssignmentHistoryDialog: false,
      workSchedulesEmployeeInfoDialog: false,
      assignmentWorkScheduleWeeks: {},
      speedDials: [],
      constants,
    };
  },

  created() {
    this.setPageTitle(this.$t('titles.manageEmpWorkSched'));
    this.resetViewRangeDates();
    this.loadWorkSchedules().then(() => {
      this.loadSubordinateEmployees().then(() => {
        this.subordinatesLoaded = true;
        this.fetchAssignedWorkScheduleRanges();
        this.assignmentWorkScheduleWeeks = reduce(
          this.subordinateAssignments,
          (accumulator, assignment) => {
            accumulator[assignment.id] = this.getStartOfCurrentWeek();
            return accumulator;
          },
          {},
        );
        this.schedulesLoaded = true;
      });
    });
  },

  computed: {
    ...mapState(['subordinateEmployees', 'tempWorkScheduleAssignmentStatusPolling', 'pendingWorkSchedules']),

    ...mapGetters(['getAssignedWorkScheduleRanges', 'getDailyWorkScheduleByEmployee']),

    subordinateAssignments() {
      return flatMap(
        map(this.subordinateEmployees, (subordinate) => map(
          filter(subordinate.subordinateAssignments, (subordinateAssignment) => subordinateAssignment.currentlyManaged),
          (subordinateAssignment) => extend(
            {},
            subordinateAssignment,
            {
              employeeName: `${subordinate.employee.lastName}, ${subordinate.employee.firstName}`,
              employeeId: subordinate.employee.id,
            },
          ),
        )),
      );
    },

    filteredSubordinateAssignments() {
      if (this.searchText == null) {
        return [];
      }

      return filter(this.subordinateAssignments, (subordinateAssignment) => this.searchText === ''
        || (this.matchesSearchFilter(subordinateAssignment.employeeName)
          || this.matchesSearchFilter(subordinateAssignment.description)
          || this.matchesSearchFilter(subordinateAssignment.id)
          || some(map(
            this.getAssignedWorkScheduleRanges(subordinateAssignment.id),
            (range) => this.matchesSearchFilter(this.getWorkScheduleCode(range))
              || this.matchesSearchFilter(this.getWorkScheduleExternalNameBySchedule(range.externalCode)),
          ))));
    },

    viewRanges() {
      return map(
        Object.values(constants.WorkSchedule.ViewRange),
        (viewRange) => ({
          text: this.getViewRangeReadableText(viewRange),
          value: viewRange,
        }),
      );
    },
  },

  watch: {
    selectedAssignmentIds() {
      this.validateAssignmentSelection();
      this.setAllAssignmentsSelected();
    },

    filteredSubordinateAssignments() {
      if (this.searchText == null) {
        this.searchText = '';
      }
      this.setAllAssignmentsSelected();
    },

    subordinateEmployees: {
      deep: true,
      handler() {
        if (this.pendingWorkSchedules.length === 0) {
          this.fetchAssignedWorkScheduleRanges();
        }
      },
    },
  },

  methods: {
    ...mapActions([
      'loadWorkSchedules',
      'loadSubordinateEmployees',
      'loadAssignedWorkScheduleRanges',
    ]),

    ...mapMutations(['setPageTitle']),

    setWorkScheduleSegments() {
      this.setDailyScheduleForEmployees(this.filteredSubordinateAssignments.map((assignment) => assignment.id));
    },

    matchesSearchFilter(value) {
      if (isNil(value)) {
        return false;
      }
      return value.toLowerCase().includes(this.searchText.toLowerCase());
    },

    async fetchAssignedWorkScheduleRanges() {
      if (this.subordinateAssignments.length !== 0) {
        this.schedulesLoaded = false;
        await this.loadAssignedWorkScheduleRanges({
          assignmentIds: map(this.subordinateAssignments, (subordinate) => subordinate.id),
          startDate: format(this.viewRange.startDate, DateTimeUtil.constants.dateFormat),
          endDate: format(this.viewRange.endDate, DateTimeUtil.constants.dateFormat),
        }).finally(() => {
          this.setWorkScheduleSegments();
          this.schedulesLoaded = true;
        });
      }
    },

    handleWorkScheduleAssignmentDialogClose() {
      this.selectedAssignmentIds = [];
      this.assignWorkSchedulesDialog = false;
    },

    approverEmployeeWorkSchedulesFilter(_, search, item) {
      search = search.toString().toLowerCase();

      return item.employeeName.toLowerCase().includes(search)
        || item.description.toLowerCase().includes(search)
        || this.getWorkScheduleExternalNameBySchedule(item.currentWorkScheduleCode).toLowerCase().includes(search)
        || this.getReadableTimeRecordingVariant(item.timeRecordingVariant).toLowerCase().includes(search);
    },

    handleWorkScheduleDetailsDialogClose() {
      this.selectedExternalCode = '';
      this.workScheduleDetailsDialog = false;
    },

    selectAllAssignments() {
      if (this.allAssignmentsSelected) {
        this.selectedAssignmentIds = map(this.filteredSubordinateAssignments,
          (subordinate) => subordinate.id);
      } else {
        this.selectedAssignmentIds = [];
      }
    },

    setAllAssignmentsSelected() {
      this.allAssignmentsSelected = this.filteredSubordinateAssignments.length === this.selectedAssignmentIds.length;
    },

    validateAssignmentSelection() {
      if (isEmpty(this.selectedAssignmentIds)) {
        this.assignmentSelectionValid = false;
        return;
      }

      const selectedAssignmentTimeRecordingVariants = map(
        this.getSelectedSubordinateAssignments(),
        (assignment) => assignment.timeRecordingVariant,
      );

      this.assignmentSelectionValid = every(
        map(
          selectedAssignmentTimeRecordingVariants,
          (timeRecordingVariant) => timeRecordingVariant === first(selectedAssignmentTimeRecordingVariants),
        ),
      );

      if (!this.assignmentSelectionValid) {
        this.showSnackbar({
          text: this.$t('snackbar.differentTimeRecordingVariant'),
          color: constants.AppColors.ERROR,
          buttonText: this.$t('actions.ok'),
          buttonHandler: () => {
          },
        });
      }
    },

    getSelectedSubordinateAssignments() {
      return filter(
        this.filteredSubordinateAssignments,
        (assignment) => includes(this.selectedAssignmentIds, assignment.id),
      );
    },

    handleIndividualTempScheduleAssignment(assignment) {
      this.selectedAssignmentIds = [assignment.id];
      this.assignSchedule();
    },

    assignSchedule() {
      this.assignWorkSchedulesDialog = true;
    },

    viewScheduleDetails(range) {
      if (range.type === 'WORK_SCHEDULE' && range.externalCode) {
        this.selectedExternalCode = range.externalCode;
        this.workScheduleDetailsDialog = true;
      }
    },

    viewWorkScheduleAssignmentHistory(assignment) {
      this.assignmentHistorySelection = assignment;
      this.workSchedulesAssignmentHistoryDialog = true;
    },

    viewAssignmentInfo(assignment) {
      this.assignmentInfoSelection = assignment;
      this.workSchedulesEmployeeInfoDialog = true;
    },

    getWorkingTimeRangeFromDay(workScheduleDay) {
      const workingSegments = filter(
        workScheduleDay.segments,
        (segment) => segment.category === constants.WorkSchedule.SegmentType.SCHEDULED_WORKING_TIME,
      );

      return isEmpty(workingSegments)
        ? this.$t('workSchedules.nonWorkingDay')
        : `${first(workingSegments).startTime} - ${last(workingSegments).endTime}`;
    },

    getReadableTimeRecordingVariant(timeRecordingVariant) {
      switch (timeRecordingVariant) {
        case (constants.WorkSchedule.TimeRecordingVariant.CLOCK_TIME):
          return this.$t('workSchedules.clockTimes');
        case (constants.WorkSchedule.TimeRecordingVariant.DURATION):
          return this.$t('tableHeaders.duration');
        default:
          return this.$t('misc.unknown');
      }
    },

    isTempWorkScheduleUpsertFailureHidden(assignment) {
      return 'tempWorkScheduleUpsertFailed' in assignment && assignment.tempWorkScheduleUpsertFailed;
    },
  },
};
</script>

<style>
.hover-pointer:hover{
  cursor: pointer;
}

.employeeRow::after{
  content: '';
  width: 100%;
  border-bottom: solid 2px #E0E0E0;
  position: absolute;
  left: 0;
  bottom: 1px;
  z-index:0;
}

</style>
